import { gql } from '@apollo/client';

export default gql`
  query getSalesforceCases($bookingReference: String!) {
    getSalesforceCases(bookingReference: $bookingReference) {
      id
      caseNumber
      status
      origin
      subject
      createdDate
      url
    }
  }
`;
